import React, { ReactNode, FC } from "react";

import { AccordionDetails } from "../../ActionsSelectors/Accordion";

/**
 * Helper component
 * Renders `children` content, wrapped in `AccordionDetails` with preset class
 */
const OptionDetails: FC<{ children?: ReactNode }> = ({ children }) => (
  <AccordionDetails
    classes={{ root: "optselector-collapse collapse", toggled: "show" }}
  >
    {children}
  </AccordionDetails>
);

export default OptionDetails;
